export class GetSaasEntityIdByExternalIdResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetSaasEntityIdByExternalIdResponse.attributeTypeMap;
    }
    constructor() {
    }
}
